module.exports = __webpack_public_path__ + "dist/media/logo--en.5055ef4f.svg";